import { FiEdit2 } from 'react-icons/fi'

export const EditButton = () => {
  return (
    <FiEdit2 size='1rem' />
  )
}
